/**
 * Types for the AI-powered PR Review feature.
 *
 * When a project has a GitHub dbt connection, users can enable
 * automated PR reviews that use an AI agent to review code changes.
 */
/** Webhook event types we handle from GitHub */
export var GithubWebhookEvent;
(function (GithubWebhookEvent) {
    GithubWebhookEvent["ISSUE_COMMENT"] = "issue_comment";
    GithubWebhookEvent["PULL_REQUEST_REVIEW_COMMENT"] = "pull_request_review_comment";
    GithubWebhookEvent["PULL_REQUEST"] = "pull_request";
})(GithubWebhookEvent || (GithubWebhookEvent = {}));
//# sourceMappingURL=prReview.js.map